import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { NgMatModule } from '../material';
import { PipesModule } from '../pipes/pipes.module';
import { PaginatorComponent } from './paginator/paginator.component';
import { TabGroupComponent } from './tab-group/tab-group.component';
import { TabComponent } from './tab/tab.component';
import { TableComponent } from './table/table.component';
import { StepperComponent } from './stepper/stepper.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DirectivesModule } from '../directives/directives.module';
import { DomainStatusComponent } from './status/domain-status/domain-status.component';
import { AccountStatusComponent } from './status/account-status/account-status.component';
import { CorporateEmailStatusComponent } from './status/corporate-email-status/corporate-email-status.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LayoutComponent } from './layout/layout.component';
import { RealmsDropdownComponent } from './realms-dropdown/realms-dropdown.component';
import { NavItemComponent } from './sidebar/nav-item/nav-item.component';
import { FilterChipListComponent } from './filter-chip-list/filter-chip-list.component';
import { TablePanelComponent } from './table-panel/table-panel.component';
import { AccordionComponent } from './accordion/accordion.component';
import { AccordionPanelComponent } from './accordion-panel/accordion-panel.component';
import { CopyTextComponent } from './copy-text/copy-text.component';

const components = [
  AccordionComponent,
  AccordionPanelComponent,
  LayoutComponent,
  HeaderComponent,
  SidebarComponent,
  NavItemComponent,
  PaginatorComponent,
  TableComponent,
  TablePanelComponent,
  TabGroupComponent,
  TabComponent,
  StepperComponent,
  TabGroupComponent,
  SpinnerComponent,
  DomainStatusComponent,
  AccountStatusComponent,
  CorporateEmailStatusComponent,
  RealmsDropdownComponent,
  FilterChipListComponent,
  CopyTextComponent,
];

@NgModule({
  declarations: components,
  exports: components,
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgMatModule,
    RouterModule,
    PipesModule,
    DirectivesModule,
  ],
})
export class ComponentsModule {
}
